import { render, staticRenderFns } from "./OrderPaymentEditDialog.vue?vue&type=template&id=a9b4552a&scoped=true"
import script from "./OrderPaymentEditDialog.vue?vue&type=script&lang=js"
export * from "./OrderPaymentEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b4552a",
  null
  
)

export default component.exports